import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import org_45id_45global from "/app/app/middleware/orgId.global.ts";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  org_45id_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "access-required": () => import("/app/app/middleware/accessRequired.ts"),
  "subscription-required": () => import("/app/app/middleware/subscriptionRequired.ts")
}